export const LIBRARY_DRAG_TYPE = 'application/x-slidetoanki-library-item';
export type LibraryDragItem = { kind: 'deck' | 'job'; id: string; folderId: string };

/** Only this page's active library item may be moved; never accept files, URLs, or folders. */
export function matchesLibraryDrag(raw: string, active: LibraryDragItem | null): boolean {
  if (!active || raw.length > 500) return false;
  try {
    const item = JSON.parse(raw);
    return (item.kind === 'deck' || item.kind === 'job') && item.kind === active.kind
      && item.id === active.id && item.folderId === active.folderId;
  } catch { return false; }
}
